import { Component } from '@verndale/core';
import serialize from 'form-serialize';

class Module extends Component {
  setupDefaults() {
    this.dom = {
      $el: this.el,
      $form: this.el._$('.rating__form'),
      $totalRatingHidden: this.el._$('.total-rating-hidden'),
      $totalRating: this.el._$('.total-rating'),
      $ratingValue: this.el._$('.rating-value__field'),
      $ratingButton: this.el._$('.submit-rating'),
      $currentRating: this.el._$('.current-rating-value__field'),
      $button: this.el._$('#like-button')
    };
    this.addRatingClass = 'share__item-like';
    this.removeRatingClass = 'share__item-liked';
  }

  addListeners() {
    this.dom.$form._on('submit', this.onSubmit.bind(this))

    if (this.dom.$button.dataset.userLogged){

      const likeButton = document.querySelector('#like-button');

      if (likeButton){

        likeButton.removeAttribute('disabled');
      }
    }
  }

  onSubmit(e) {
    e.preventDefault();

    const headers = {
      'content-type': 'application/json'
    };

    const token = this.dom.$form._$('[name=__RequestVerificationToken]')?.value;
    if (token) headers.__RequestVerificationToken = token;

    window.fetch(this.dom.$form.action, {
      method: 'POST',
      body: JSON.stringify(serialize(this.dom.$form, { hash: true, disabled: true, empty: true })),
      headers
    }).then(r => r.json()).then(res => {
      if (res.success) {

        this.onSuccess(res);
      } else {
        this.onError();
      }
    }).catch(this.onError.bind(this));
  }

  onSuccess(res) {
    if (res.totalRating < parseInt(this.dom.$totalRating.innerText)){
      this.dom.$ratingButton.classList.add(this.addRatingClass);
      this.dom.$ratingButton.classList.remove(this.removeRatingClass);
    } else {
      this.dom.$ratingButton.classList.add(this.removeRatingClass);
      this.dom.$ratingButton.classList.remove(this.addRatingClass);
    }

    this.dom.$totalRatingHidden.value = res.totalRating;
    this.dom.$totalRating.innerText = res.totalRating;
    this.dom.$currentRating.value = res.currentRating;
  }

  onError() {

  }
}

export default Module;
